import { useTranslation } from 'react-i18next';
import { ProductAdviceTitle } from './V2Common.styles';
import ExpertSeedAdvice from './Sections/ExpertSeedAdvice';
import ProductComparison from './Sections/ProductComparison/ProductComparison';
import { BrazilProductComparison } from './Sections/BrazilProductComparison/BrazilProductComparison';
import ProductPerformance from './Sections/ProductPerformance';
import { Tpr } from 'base/types/RecommendationCropwise';

interface ProductAdviceProps {
  isMobile: boolean;
  isLoadingBreakoutsAPI: boolean;
  isLoadingBreakoutsProductSummaryAPI: boolean;
  isLoadingAttributesAPI: boolean;
  ProductComparisonRef: any;
  ExpertSeedRef: any;
  ProductPerformRef: any;
  onClickToSeeDetails?: () => void;
  handleProductSelection?: (productName: string) => void;
  isBrazil: boolean;
  isRecommendationAPILoading: boolean;
  environmentalStressChartInfo: Tpr;
}

const ProductAdvice = ({
  isMobile,
  isLoadingBreakoutsAPI,
  isLoadingBreakoutsProductSummaryAPI,
  isLoadingAttributesAPI,
  ProductComparisonRef,
  ExpertSeedRef,
  ProductPerformRef,
  onClickToSeeDetails,
  handleProductSelection,
  isBrazil,
  isRecommendationAPILoading,
  environmentalStressChartInfo,
}: ProductAdviceProps) => {
  const [t] = useTranslation();
  return (
    <>
      <ProductAdviceTitle data-testid="product-advice-section">
        {t('Product Advice')}
      </ProductAdviceTitle>
      <ExpertSeedAdvice
        isLoading={isLoadingBreakoutsAPI || isLoadingBreakoutsProductSummaryAPI}
        sectionRef={ExpertSeedRef}
        isMobile={isMobile}
        onClickToSeeDetails={onClickToSeeDetails}
        handleOnClick={handleProductSelection}
        isRecommendationAPILoading={isRecommendationAPILoading}
      />
      {!isLoadingAttributesAPI && !isBrazil && (
        <ProductComparison sectionRef={ProductComparisonRef} />
      )}
      {isBrazil && (
        <BrazilProductComparison sectionRef={ProductComparisonRef} />
      )}
      {!isBrazil &&
        environmentalStressChartInfo &&
        Object.keys(environmentalStressChartInfo).length > 0 && (
        <ProductPerformance
          sectionRef={ProductPerformRef}
          chartInfo={environmentalStressChartInfo}
        />
      )}
    </>
  );
};

export default ProductAdvice;
